module.exports = __webpack_public_path__ + "img/GH-kyujin-jimu002.f761a987.webp";